import { Flex } from '@chakra-ui/react';

import { NavigationEntity } from 'hooks/useNavigationEntities';

const NavigationEntityIcon = ({ entity }: { entity: NavigationEntity }) => {
  if (entity.icon == null) {
    return null;
  }

  return (
    <Flex
      color="text.primary"
      width={6}
      height={6}
      fontSize="sm"
      justifyContent="center"
      alignItems="center"
    >
      {entity.icon}
    </Flex>
  );
};

export default NavigationEntityIcon;
